import { Injectable } from '@angular/core';

function getWindow(): Window {
  return window;
}

@Injectable({
  providedIn: 'root',
})
export class WindowRef {
  get nativeWindow(): Window {
    return getWindow();
  }
}
